<div class="naplo-fejlec">
  <h2>Társasház</h2>
  <div class="spacer"></div>
  <span style="font-size:.82rem;opacity:.9" *ngIf="albetetek.length">
    {{ albetetek.length }} albetét · összes hányad {{ osszHanyad | number:'1.0-4' }}
  </span>
</div>

<div class="ures" *ngIf="!aktiv.ugyfelId"><ion-icon name="business"></ion-icon>Válassz ügyfelet.</div>

<!-- Ha az ügyfél nincs társasháznak jelölve, itt szólunk – a beállítás az Ügyfelek
     képernyőn, az „Ügyfél típusa" kapcsolóval történik. -->
<div class="ures" *ngIf="aktiv.ugyfelId && aktiv.tipus !== 'tarsashaz'" style="flex-direction:column;gap:10px">
  <ion-icon name="home-outline"></ion-icon>
  <div><b>{{ aktiv.ugyfelNev }}</b> nincs társasháznak jelölve.</div>
  <div style="font-size:.85rem;color:#64748b;max-width:520px;text-align:center">
    Az Ügyfelek képernyőn, az ügyfél szerkesztésénél az <b>Ügyfél típusa</b> kapcsolót állítsd
    <b>Társasház</b>-ra – onnantól itt kezelheted az albetéteket és a havi közös költséget.
  </div>
  <ion-button size="small" style="--background:var(--naplo)" routerLink="/naplo/ugyfelek">
    <ion-icon slot="start" name="business"></ion-icon>Ugrás az ügyfelekhez
  </ion-button>
</div>

<ng-container *ngIf="aktiv.ugyfelId && aktiv.tipus === 'tarsashaz'">
  <!-- Albetétek (lakók) -->
  <div class="naplo-eszkozsor">
    <h3 style="margin:0;color:var(--naplo)">Albetétek</h3>
    <div class="spacer" style="flex:1"></div>
    <input type="file" (change)="albetetImport($event)" hidden #albetetFile>
    <ion-button size="small" fill="outline" (click)="albetetFile.click()" [disabled]="importFut"
      title="Lakólista betöltése táblázatból (XLS/XLSX/CSV/DBF). Felismert oszlopok: albetét/hrsz, megnevezés, tulajdonos, tulajdoni hányad, terület">
      <ion-spinner *ngIf="importFut" name="dots"></ion-spinner>
      <span *ngIf="!importFut"><ion-icon slot="start" name="cloud-upload-outline"></ion-icon>Lakók betöltése</span>
    </ion-button>
    <ion-button size="small" fill="outline" (click)="lakokExport()" [disabled]="!albetetek.length"
      title="A jelenlegi lakólista mentése CSV-be – ugyanez a fájl változtatás nélkül visszatölthető">
      <ion-icon slot="start" name="download-outline"></ion-icon>Lakók exportálása
    </ion-button>
    <ion-button size="small" fill="clear" (click)="sablonLetolt()" title="Minta-táblázat a felismert oszlopnevekkel">
      <ion-icon slot="start" name="document-text-outline"></ion-icon>Minta-sablon
    </ion-button>
    <ion-button size="small" style="--background:var(--naplo)" (click)="ujAlbetet()">
      <ion-icon slot="start" name="add"></ion-icon>Új albetét
    </ion-button>
  </div>

  <!-- Mit vár az import? Enélkül csak találgatás, milyen fájlt kell összerakni. -->
  <ion-note color="medium" style="display:block;margin:0 0 10px;font-size:.79rem;line-height:1.5">
    A <b>lakólista</b> egy táblázat (XLS / XLSX / CSV / DBF), fejléccel. Felismert oszlopnevek:
    <b>Albetét</b> (vagy hrsz / helyrajzi / lakás / sorszám) · <b>Megnevezés</b> (emelet, leírás) ·
    <b>Tulajdonos</b> (név / lakó) · <b>RLB partner</b> · <b>Partnerkód</b> ·
    <b>Tulajdoni hányad</b> (ezrelék; „1234/10000" és „12,34" is jó) · <b>Terület</b> (m²) ·
    <b>Díjkategória</b> · <b>Fix költség</b> · <b>Aktív</b> · <b>Megjegyzés</b>.
    Csak az albetét kötelező, a hiányzó oszlopokhoz nem nyúlunk. Az albetét azonosít: újbóli
    betöltésnél frissül, nem duplikálódik.
    A <b>Lakók exportálása</b> pontosan ilyen fájlt ad a mostani listáról – az változtatás nélkül,
    vagy Excelben átírva visszatölthető.
  </ion-note>

  <div class="ures" *ngIf="!albetetek.length">
    <ion-icon name="home-outline"></ion-icon>
    Még nincs albetét. Töltsd be a lakólistát, vagy vedd fel egyenként.
  </div>

  <div class="tabla-wrap" *ngIf="albetetek.length">
    <table class="naplo-tabla">
      <thead><tr>
        <th>Albetét</th><th>Megnevezés</th><th>Tulajdonos</th><th>RLB partner</th><th>Díjkategória</th>
        <th class="jobb">Hányad</th><th class="jobb">Arány</th><th class="jobb">Fix költség</th>
        <th class="jobb">Műveletek</th>
      </tr></thead>
      <tbody>
        <tr *ngFor="let a of albetetek" [class.halvany]="!a.aktiv">
          <td><b>{{ a.albetet }}</b></td>
          <td>{{ a.megnevezes || '—' }}</td>
          <td>{{ a.tulajdonos || '—' }}</td>
          <td>
            {{ a.rlb_partner || '—' }}
            <ion-badge color="warning" *ngIf="!a.rlb_partner" title="Az RLB-be ezzel a névvel megy a számla – érdemes a partnertörzsből választani">nincs párosítva</ion-badge>
          </td>
          <td>{{ kategoriaNev(a.dij_kategoria) }}</td>
          <td class="jobb">{{ a.hanyad | number:'1.0-4' }}</td>
          <td class="jobb">{{ arany(a) | number:'1.2-2' }}%</td>
          <td class="jobb">{{ a.fix_koltseg ? (a.fix_koltseg | number:'1.0-0') + ' Ft' : '—' }}</td>
          <td class="jobb muveletek">
            <ion-button size="small" fill="clear" title="Szerkesztés" (click)="szerkeszt(a)"><ion-icon slot="icon-only" name="create-outline"></ion-icon></ion-button>
            <ion-button size="small" fill="clear" color="danger" title="Törlés" (click)="albetetTorol(a)"><ion-icon slot="icon-only" name="trash-outline"></ion-icon></ion-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Albetét szerkesztő -->
  <div class="kezi-szamla" *ngIf="szerk">
    <ion-card class="naplo-card">
      <ion-card-content>
        <ion-grid><ion-row>
          <ion-col size="6" sizeMd="2"><ion-item><ion-input label="Albetét *" labelPlacement="stacked" [(ngModel)]="szerk.albetet"></ion-input></ion-item></ion-col>
          <ion-col size="6" sizeMd="3"><ion-item><ion-input label="Megnevezés" labelPlacement="stacked" placeholder="II. em. 4." [(ngModel)]="szerk.megnevezes"></ion-input></ion-item></ion-col>
          <ion-col size="12" sizeMd="3"><ion-item><ion-input label="Tulajdonos" labelPlacement="stacked" [(ngModel)]="szerk.tulajdonos"></ion-input></ion-item></ion-col>
          <ion-col size="12" sizeMd="4">
            <label class="alias-cimke">RLB partner (erre a névre megy a számla)</label>
            <input class="alias-input" [(ngModel)]="szerk.rlb_partner" list="rlbPartnerLista" placeholder="válaszd ki vagy gépeld" autocomplete="off">
            <datalist id="rlbPartnerLista"><option *ngFor="let n of rlbPartnerek" [value]="n"></option></datalist>
          </ion-col>
          <ion-col size="6" sizeMd="3"><ion-item><ion-input label="Tulajdoni hányad" labelPlacement="stacked" placeholder="1234/10000 vagy 12,34" [(ngModel)]="szerk.hanyad"></ion-input></ion-item></ion-col>
          <ion-col size="6" sizeMd="2"><ion-item><ion-input label="Terület (m²)" labelPlacement="stacked" [(ngModel)]="szerk.terulet"></ion-input></ion-item></ion-col>
          <ion-col size="6" sizeMd="3"><ion-item><ion-input label="Fix költség (Ft)" labelPlacement="stacked" placeholder="ha nem hányad szerint fizet" [(ngModel)]="szerk.fix_koltseg"></ion-input></ion-item></ion-col>
          <ion-col size="6" sizeMd="3">
            <ion-item><ion-select label="Díjkategória" labelPlacement="stacked" interface="popover" [(ngModel)]="szerk.dij_kategoria">
              <ion-select-option *ngFor="let k of kategoriak" [value]="k.kategoria">{{ k.nev }}</ion-select-option>
            </ion-select></ion-item>
          </ion-col>
          <ion-col size="6" sizeMd="2"><ion-item lines="none"><ion-toggle [(ngModel)]="szerk.aktiv">Aktív</ion-toggle></ion-item></ion-col>
        </ion-row></ion-grid>
        <ion-button size="small" style="--background:var(--naplo)" (click)="albetetMent()"><ion-icon slot="start" name="save"></ion-icon>Mentés</ion-button>
        <ion-button size="small" fill="clear" color="medium" (click)="szerk = null">Mégse</ion-button>
      </ion-card-content>
    </ion-card>
  </div>

  <!-- Egységár-törzs: a vízórás és a vízóra nélküli albetét díja eltér -->
  <div class="naplo-eszkozsor" style="margin-top:18px">
    <h3 style="margin:0;color:var(--naplo)">Egységárak</h3>
    <div class="spacer" style="flex:1"></div>
    <ion-button size="small" fill="outline" (click)="ujDijSor()"><ion-icon slot="start" name="add"></ion-icon>Új egységár</ion-button>
  </div>
  <ion-note color="medium" style="display:block;margin:0 0 8px;font-size:.79rem">
    Kategóriánként egy-egy díj, <b>érvényességi kezdettel</b> – a havi kiírás ebből számol, nem kézzel adod meg.
    <b>Díjemeléskor</b> vegyél fel új sort az új kezdettel: a korábbi hónapok ára változatlan marad.
    <b>Elgépelést</b> a sor végi ceruzával javíts – az a meglévő árat írja át, visszamenőleg is.
    Az egységár <b>Ft / tulajdoni hányad egység</b> (ha a hányad 1234/10000 alakban van, akkor a teljes ház díja).
  </ion-note>

  <div class="tabla-wrap" *ngIf="dijak.length">
    <table class="naplo-tabla">
      <thead><tr><th>Kategória</th><th class="jobb">Egységár</th><th>Érvényes ettől</th><th class="jobb">Műveletek</th></tr></thead>
      <tbody>
        <tr *ngFor="let d of dijak">
          <td>{{ d.nev || kategoriaNev(d.kategoria) }}</td>
          <td class="jobb">{{ d.egysegar | number:'1.0-2' }} Ft</td>
          <td>{{ d.ervenyes_tol | date:'yyyy.MM.dd' }}</td>
          <td class="jobb muveletek">
            <ion-button size="small" fill="clear" title="Egységár módosítása" (click)="dijModosit(d)"><ion-icon slot="icon-only" name="create-outline"></ion-icon></ion-button>
            <ion-button size="small" fill="clear" color="danger" title="Törlés" (click)="dijTorol(d)"><ion-icon slot="icon-only" name="trash-outline"></ion-icon></ion-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="ures" *ngIf="!dijak.length" style="padding:12px">
    <ion-icon name="pricetag-outline"></ion-icon>Még nincs egységár. Vegyél fel egyet a vízórás és egyet a vízóra nélküli kategóriára.
  </div>

  <div class="kezi-szamla" id="egysegar-szerkeszto" *ngIf="dijSzerk">
    <ion-card class="naplo-card"><ion-card-content>
      <h4 style="margin:0 8px 4px;color:var(--naplo);font-size:.92rem">
        {{ dijSzerk.id ? 'Egységár módosítása' : 'Új egységár' }}
      </h4>
      <ion-grid><ion-row class="ion-align-items-end">
        <ion-col size="12" sizeMd="4"><ion-item><ion-select label="Kategória" labelPlacement="stacked" interface="popover"
          [ngModel]="dijSzerk.kategoria" (ngModelChange)="dijKategoriaValt($event)">
          <ion-select-option *ngFor="let k of kategoriak" [value]="k.kategoria">{{ k.nev }}</ion-select-option>
        </ion-select></ion-item></ion-col>
        <ion-col size="6" sizeMd="3"><ion-item><ion-input label="Egységár (Ft)" labelPlacement="stacked" type="number" [(ngModel)]="dijSzerk.egysegar"></ion-input></ion-item></ion-col>
        <ion-col size="6" sizeMd="3"><ion-item><ion-input label="Érvényes ettől" labelPlacement="stacked" type="date" [(ngModel)]="dijSzerk.ervenyes_tol"></ion-input></ion-item></ion-col>
      </ion-row></ion-grid>
      <ion-note *ngIf="dijSzerk.id" color="medium" style="display:block;margin:0 8px 8px;font-size:.78rem">
        A módosítás <b>minden</b> olyan hónapra hat, amelyikre ez a sor érvényes (a kiírás mindig
        ebből számol), így a már exportált és az RLB-be beolvasott számlák összegétől eltérhet.
        Ha a díj csak mostantól emelkedik, inkább vegyél fel új sort az új kezdettel.
      </ion-note>
      <ion-button size="small" style="--background:var(--naplo)" (click)="dijMent(dijSzerk)"><ion-icon slot="start" name="save"></ion-icon>Mentés</ion-button>
      <ion-button size="small" fill="clear" color="medium" (click)="dijSzerk = null">Mégse</ion-button>
    </ion-card-content></ion-card>
  </div>

  <!-- Havi közös költség -->
  <div class="naplo-eszkozsor" style="margin-top:18px">
    <h3 style="margin:0;color:var(--naplo)">Havi közös költség</h3>
    <div class="spacer" style="flex:1"></div>
    <ion-input style="max-width:110px" fill="outline" type="number" label="Év" labelPlacement="stacked" [(ngModel)]="ev" (ionBlur)="honapValt()"></ion-input>
    <ion-select style="min-width:120px" fill="outline" label="Hónap" labelPlacement="stacked" interface="popover" [(ngModel)]="honap" (ngModelChange)="honapValt()">
      <ion-select-option *ngFor="let h of [1,2,3,4,5,6,7,8,9,10,11,12]" [value]="h">{{ h }}. hó</ion-select-option>
    </ion-select>
  </div>

  <ion-card class="naplo-card">
    <ion-card-content>
      <ion-grid><ion-row class="ion-align-items-end">
        <ion-col size="12" sizeMd="3">
          <ion-item><ion-select label="Számítás" labelPlacement="stacked" interface="popover" [(ngModel)]="kiiras.szamitas">
            <ion-select-option value="osszeg">Havi keret szétosztva</ion-select-option>
            <ion-select-option value="egysegar">Hányad × egységár</ion-select-option>
          </ion-select></ion-item>
        </ion-col>
        <ion-col size="6" sizeMd="2" *ngIf="kiiras.szamitas === 'osszeg'">
          <ion-item><ion-input label="Havi keret (Ft)" labelPlacement="stacked" type="number" [(ngModel)]="kiiras.osszeg"></ion-input></ion-item>
        </ion-col>
        <ion-col size="6" sizeMd="3">
          <ion-item><ion-select label="Mire vetítve" labelPlacement="stacked" interface="popover" [(ngModel)]="kiiras.vetites">
            <ion-select-option value="terulet">Alapterület (m²)</ion-select-option>
            <ion-select-option value="hanyad">Tulajdoni hányad</ion-select-option>
          </ion-select></ion-item>
        </ion-col>
        <ion-col size="12" sizeMd="3" *ngIf="kiiras.szamitas === 'osszeg'">
          <ion-note color="medium" style="display:block;font-size:.78rem;padding:0 8px 6px">
            A keretet a választott alap arányában osztjuk szét; a kerekítési maradék a legnagyobb
            alapú albetétre kerül, így az összeg forintra a keret lesz.
          </ion-note>
        </ion-col>
        <ion-col size="12" sizeMd="3" *ngIf="kiiras.szamitas === 'egysegar'">
          <ion-note color="medium" style="display:block;font-size:.78rem;padding:0 8px 6px">
            Az egységár az <b>Egységárak</b> törzsből jön, az albetét díjkategóriája szerint.
            <span *ngIf="!dijak.length" style="color:var(--ion-color-danger)">Még nincs felvéve egy sem!</span>
            <span class="dij-sor" *ngFor="let d of ervenyesDijak">
              {{ d.nev || kategoriaNev(d.kategoria) }}: <b>{{ d.egysegar | number:'1.0-2' }} Ft</b>
              <a (click)="dijModosit(d)" title="Az egységár átírása">módosítás</a>
            </span>
          </ion-note>
        </ion-col>
        <ion-col size="12" sizeMd="3"><ion-item><ion-input label="Megjegyzés (a számlán)" labelPlacement="stacked" placeholder="Közös költség {{ev}}. {{honap}}. hó" [(ngModel)]="kiiras.megnevezes"></ion-input></ion-item>
          <ion-note color="medium" style="display:block;font-size:.75rem;padding:0 12px">Szó szerint ez megy a számla megjegyzésébe – az albetét számát nem fűzzük hozzá.</ion-note>
        </ion-col>
        <ion-col size="4" sizeMd="1"><ion-item><ion-input label="Vevő fsz." labelPlacement="stacked" [(ngModel)]="kiiras.vevo_szamla"></ion-input></ion-item></ion-col>
        <ion-col size="4" sizeMd="1"><ion-item><ion-input label="Bevétel fsz." labelPlacement="stacked" [(ngModel)]="kiiras.bevetel_szamla"></ion-input></ion-item></ion-col>
        <ion-col size="4" sizeMd="2"><ion-item><ion-input label="ÁFA kód" labelPlacement="stacked" placeholder="üres = nem áfás" [(ngModel)]="kiiras.afa_kod"></ion-input></ion-item></ion-col>
      </ion-row></ion-grid>
      <ion-button size="small" style="--background:var(--naplo)" (click)="kiirasMent()" [disabled]="szamitFut">
        <ion-spinner *ngIf="szamitFut" name="dots"></ion-spinner>
        <span *ngIf="!szamitFut"><ion-icon slot="start" name="calculator-outline"></ion-icon>Kiírás kiszámítása</span>
      </ion-button>
      <ion-button size="small" fill="outline" (click)="rlbExport()" [disabled]="exportFut || !tetelek.length">
        <ion-spinner *ngIf="exportFut" name="dots"></ion-spinner>
        <span *ngIf="!exportFut"><ion-icon slot="start" name="download-outline"></ion-icon>RLB vevőszámla-export</span>
      </ion-button>
      <ion-note *ngIf="hianyzoAlap" color="danger" style="display:block;margin-top:8px;font-size:.78rem">
        {{hianyzoAlap}} albetétnél hiányzik a vetítési alap ({{kiiras.vetites === 'terulet' ? 'alapterület' : 'tulajdoni hányad'}}) – ezekre 0 Ft-os számla készülne.
      </ion-note>
      <ion-note *ngIf="ismetlodoJeloles" color="warning" style="display:block;margin-top:8px;font-size:.78rem">
        {{ismetlodoJeloles}} albetét megnevezése ismétlődik (pl. több „II. em."), ezért ezeknél a bizonylatszám
        zárójelben az albetét sorszámát is tartalmazza – az RLB-ben a bizonylatszámnak egyedinek kell lennie.
        Ha megadod a pontos albetét-jelöléseket a megnevezésnél, a zárójel eltűnik.
      </ion-note>
      <ion-note color="medium" style="display:block;margin-top:8px;font-size:.78rem">
        A bizonylatszám az <b>albetét megnevezése + a hónap</b> (pl. <code>Pince 2/{{honap < 10 ? '0' : ''}}{{honap}}.</code>),
        így a banki kivonatból is hivatkozható. A számla kelte és teljesítése a hónap 1-je, a fizetési határidő 15-e.
      </ion-note>
    </ion-card-content>
  </ion-card>

  <div class="tabla-wrap" *ngIf="tetelek.length">
    <table class="naplo-tabla">
      <thead><tr>
        <th>Albetét</th><th>Bizonylatszám</th><th>Tulajdonos / RLB partner</th><th>Díjkategória</th><th class="jobb">Hányad</th>
        <th class="jobb">{{ kiiras.vetites === 'terulet' ? 'Alap (m²)' : 'Alap (hányad)' }}</th>
        <th class="jobb">{{ kiiras.szamitas === 'osszeg' ? 'Fajlagos' : 'Egységár' }}</th><th class="jobb">Fizetendő</th>
      </tr></thead>
      <tbody>
        <tr *ngFor="let t of tetelek">
          <td><b>{{ t.albetet }}</b> <span class="halvany">{{ t.megnevezes }}</span></td>
          <td><code>{{ t.bizonylat }}</code></td>
          <td>{{ t.rlb_partner || t.tulajdonos || '—' }}</td>
          <td>{{ kategoriaNev(t.dij_kategoria) }}</td>
          <td class="jobb">{{ t.hanyad | number:'1.0-4' }}</td>
          <td class="jobb">{{ t.vetitesi_alap != null ? (t.vetitesi_alap | number:'1.0-2') : ((t.arany * 100) | number:'1.2-2') + '%' }}</td>
          <td class="jobb">{{ t.fix ? 'fix' : (t.egysegar != null ? (t.egysegar | number:'1.0-0') + ' Ft' : '—') }}</td>
          <td class="jobb"><b>{{ t.osszeg | number:'1.0-0' }} Ft</b></td>
        </tr>
      </tbody>
      <tfoot><tr>
        <td colspan="7" class="jobb"><b>Összesen</b></td>
        <td class="jobb"><b>{{ osszesen | number:'1.0-0' }} Ft</b></td>
      </tr></tfoot>
    </table>
  </div>
</ng-container>
